import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Post } from '../../../app/models/Post'
import { history } from '../../..'
import PostImagesSwiper from '../PostImagesSwiper'
import { useStore } from '../../../app/stores/store'
import { FilterModes } from '../../../app/models/modes'

interface Props {
  post: Post
}

function PostCard({ post }: Props) {
  const { userStore, favoriteAuctionsStore } = useStore()
  const { addFavorite, removeFavorite, findFavorite, loadingFavorites } = favoriteAuctionsStore
  const [loadingBtn, setLoadingBtn] = useState(false)
  const { t } = useTranslation()

  const handleDetails = (slug: string) => {
    history.push(`/posts/${slug}`)
  }

  const handleAddFav = () => {
    if (!userStore.isLoggedIn) {
      toast.error('Please log in')
    } else {
      setLoadingBtn(true)
      addFavorite(post.id, FilterModes.post).finally(() => setLoadingBtn(false))
    }
  }

  const handleRemoveFav = () => {
    setLoadingBtn(true)
    removeFavorite(post.id, post?.title as string, FilterModes.post).finally(() =>
      setLoadingBtn(false),
    )
  }

  const favButtons = [
    {
      icon: 'fa-regular fa-heart',
      onClick: handleAddFav,
      show: !findFavorite(post.id),
    },
    {
      icon: 'fa-solid fa-heart',
      onClick: handleRemoveFav,
      show: findFavorite(post.id),
    },
  ]

  return (
    <div className='auction-card'>
      <div className='auction-card-header'>
        <PostImagesSwiper
          id={post.id}
          width={600}
          slug={post.slug}
          postImages={post?.postImages || []}
          type={FilterModes.post}
          postStatus={post.status}
        />
      </div>
      <div className='auction-card-body'>
        <header>
          <h1>{post.title}</h1>
          {loadingFavorites || loadingBtn ? (
            <button>
              <Spinner size='sm' animation='border' variant='light' />
            </button>
          ) : (
            favButtons.map(
              (btn, index) =>
                btn.show && (
                  <button key={index} onClick={btn.onClick}>
                    <i className={btn.icon} />
                  </button>
                ),
            )
          )}
        </header>
        <hr className='auction-card-line mb-2' />
        <main>
          <h5>
            {post.address}, {post.city} {post.zipCode}
          </h5>
          <h6>
            <em>
              {post?.rooms} {t('room')}, {post.meters} m²
            </em>
          </h6>
          <p>
            {`${post?.description.slice(0, 250).trim()}${
              post?.description.length || 0 > 250 ? '...' : ''
            }`}
          </p>
        </main>
        <footer>
          <div className='auction-card-body-footer d-flex justify-content-end'>
            <button className='auction-card-body-button' onClick={() => handleDetails(post.slug)}>
              {t('details')}
            </button>
          </div>
        </footer>
      </div>
    </div>
  )
}
export default observer(PostCard)
